import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=5a5dc512&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=ts&"
export * from "./deleteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=5a5dc512&lang=scss&scoped=true&"
import style1 from "./deleteDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5dc512",
  null
  
)

export default component.exports